"use client";

import { useEffect, useRef, useState } from "react";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
export default function OurPhilosophy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  return <section data-section-id="231876" id="full-service-marketing-solutions" className="bg-background min-h-screen flex flex-col items-center justify-center py-32 px-6 md:px-12 lg:px-24 overflow-hidden">
            <div ref={ref} className={`max-w-7xl mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <p className="font-default text-4xl md:text-5xl lg:text-[64px] leading-[1.3] text-foreground tracking-tight font-bold">
                    We believe marketing is not merely a service,<br className="hidden md:block" />
                    but a <span className="italic font-serif font-light text-primary">strategic bridge</span> to your community.<br className="hidden md:block" />
                    The Peachtree Post delivers premium mailers<br className="hidden md:block" />
                    defined by <span className="italic font-serif font-light text-primary">precision, prestige</span>, and absolute results.
                </p>
            </div>
        </section>;
}